interface Zona {
  descripcion: string;
  azureId: string;
  value: string;
}

interface Usuario {
  roles: string[];
  zonasAsignadas: Zona[];
}

interface Permiso {
  rol: string;
  zonas: string[];
}

interface ControlAcceso {
  activo: boolean;
  isAdmin: boolean;
  cargando: boolean,
  permisos: Permiso[];
  usuario: Usuario;
  tienePermiso(): boolean;
  puedeVerMenu(): boolean;
  obtenerInfo(): Promise<void>;
}

import Vue from 'vue'; 
import Azure from "@/Services/AzureServices";
import ZonaServices from "@/Services/ZonaServices";

//las zonas permitidas PRE: "LABORATORIO_NORTE", AND._ORIENTAL, AND._OCCIDENTAL, MARKETING_ZONA, MADRID y CATALUNA
//las zonas de PROD: 
// SPECIAL MARKETS PORTUGAL
// PORTUGAL CLINICA
// SPECIAL MARKETS ESPANA
// NORTE
// CATALUNA
// LEVANTE
// CENTRO
// AND. OCCIDENTAL
// AND. ORIENTAL
// CANARIAS
// LABORATORIO NORTE
// LABORATORIO SUR
// LABORATORIO PORTUGAL
// MARKETING ZONA
export const controlAcceso: ControlAcceso = {
  activo: false,
  permisos: [
    // { rol: 'G_ES_CPQ_UG_Administrador', zonas: ['*'] }, // '*' significa acceso desde cualquier zona
    // { rol: 'G_ES_CPQ_UG_Marketing', zonas: ['MADRID', 'LABORATORIO_NORTE'] },
    // { rol: 'G_ES_CPQ_UG_Comercial', zonas: ['MADRID'] },
    // { rol: 'G_ES_CPQ_UG_Director-Regional', zonas: ['CATALUNA', 'MADRID'] },
    { rol: 'G_ES_CPQ_UG_RSA', zonas: ['*']},
    { rol: 'G_ES_CPQ_UG_Director-General', zonas: ['*']}
  ],
  usuario: {
    roles: [],
    zonasAsignadas: [],
  },
  isAdmin: false,
  cargando: false,

  tienePermiso() {
    if (!this.activo || this.isAdmin) return true;

    const zonasLibres = ['CATALUNA', 'NORTE', 'LABORATORIO_NORTE', 'LEVANTE', 'CENTRO', 'AND._OCCIDENTAL', 'LABORATORIO_SUR', 'LABORATORIO_PORTUGAL'];
    if (this.usuario.zonasAsignadas.some(z => zonasLibres.includes(z.value.trim().toUpperCase()))) {
      return true;
    }

    return this.usuario.roles.some(rolUsuario => {
      const permiso = this.permisos.find(p => p.rol === rolUsuario);
      if (!permiso) return false;

      return permiso.zonas.includes('*') || this.usuario.zonasAsignadas.some(z =>
        permiso.zonas.includes(z.value)
      );
    });
  },
  puedeVerMenu() {
    return this.tienePermiso();
  },

  async obtenerInfo(){
    this.cargando = true;
    const [userInfo,allRoles] = await Promise.all([
        Azure.getME(),
        Azure.getAllRoles()
    ]);

    const roles = Vue.prototype.$roles;
    this.isAdmin = roles.includes('G_ES_CPQ_UG_Administrador') || roles.includes('G_ES_CPQ_UG_Marketing');

    const zonasAsignadas = allRoles
        .filter(x => x.description.toUpperCase() === "ZONE" && roles.includes(x.value))
        .map(x => { return { descripcion: x.displayName, azureId: x.id, value: x.value } });

    const allZones = allRoles
        .filter(x => x.description.toUpperCase() === "ZONE")
        .map(x => { return { descripcion: x.displayName, azureId: x.id, value: x.value } });

    try {
      await ZonaServices.createZonas(            
        allZones
      );
    } catch (error) {
      console.error(error);
    }

    this.usuario.roles = roles;
    this.usuario.zonasAsignadas = zonasAsignadas;

    this.cargando = false;
  }
};
